import React from 'react';
import { learnMode } from '../data/siteContent';

/**
 * Detail-plate layout: the screenshot takes the wider share, the text sits
 * beside it as an annotation rather than the other way round.
 */
const LearnModeSection: React.FC = () => {
  return (
    <section className="section-y">
      <div className="shell">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-gutter">
          <figure className="order-2 mx-auto w-full max-w-[17rem] lg:order-1 lg:col-span-5 lg:max-w-[20rem]">
            <div className="plate bg-background p-2">
              <img
                src="/screenshots/iphone/02-inflection.png"
                width={1320}
                height={2868}
                alt="Lexeme showing andiamo resolved to the verb andare, with pronunciation and full definitions"
                className="block h-auto w-full"
                loading="lazy"
                decoding="async"
              />
            </div>
            <figcaption className="mt-4 flex items-baseline gap-3 border-t border-ink/15 pt-3">
              <span className="whitespace-nowrap font-display text-sm text-primary" aria-hidden="true">
                Pl. 02
              </span>
              <span className="prose-note text-[0.875rem]">
                After the guess: the whole entry, with the form traced back to its lemma.
              </span>
            </figcaption>
          </figure>

          <div className="order-1 lg:order-2 lg:col-span-7">
            <p className="kicker-action">{learnMode.eyebrow}</p>
            <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[2.85rem]">{learnMode.title}</h2>
            <p className="prose-reading mt-6 max-w-reading">{learnMode.body}</p>

            <ul className="mt-9 list-none">
              {learnMode.points.map((point) => (
                <li
                  key={point}
                  className="flex gap-4 border-t border-ink/12 py-4 first:border-t-0 first:pt-0"
                >
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-primary" aria-hidden="true" />
                  <span className="prose-note">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearnModeSection;
